import {
  SMS_TEMPLATE_CREATED,
  SMS_TEMPLATE_ERROR,
  DELETE_SMS_TEMPLATE,
  SMS_TEMPLATE_UPDATED,
  SMS_TEMPLATE_LIST_UPDATED,
  GET_SMS_TEMPLATE_BY_ID,
  LOADING_ON_SMS_SUBMIT,
  SMS_TEMPLATE_SEARCH_PARAMATERS_UPDATE,
  CHANGE_SMS_TEMPLATE_STATUS,
  LOAD_PAGE,
  LOADING_SMS_LIST_DATA,
  RESET,
} from "actions/types";
import * as Constants from "constants/index";

const initialState = {
  smsTemplateList: {
    page: 1,
    data: [],
    count: 0
  },
  currentSMSTemplate: [],
  loadingSMSList: true,
  loadingSMS: true,
  loadingListData: true,
  performDelete: false,
  error: {},
  sortingParams: {
    limit: Constants.DEFAULT_PAGE_SIZE,
    page: 1,
    orderBy: "created_at",
    ascending: "desc",
    query: ""
  }
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESET:
      return {
        ...initialState,
        loadingSMS: state.loadingSMS,
        loadingSMSList:state.loadingSMSList,
        loadingListData: state.loadingListData,
      }
    case LOAD_PAGE:
      return {
        ...state,
        loadingSMS: false
      };
    case SMS_TEMPLATE_CREATED:
      return {
        ...state,
        loadingSMS: false
      };
    case SMS_TEMPLATE_UPDATED:
      return {
        ...state,
        currentSMSTemplate: payload,
        sortingParams: initialState.sortingParams,
        loadingSMS: false
      };
    case SMS_TEMPLATE_ERROR:
      return {
        ...state,
        error: payload,
        loadingSMS: false,
        loadingSMSList: false,
        loadingListData: false,
        performDelete: false,
      };
    case DELETE_SMS_TEMPLATE:
      const currentCount = state.smsTemplateList.count;
      const currentLimit = state.sortingParams.limit;
      const currentPage = parseInt(state.smsTemplateList.page);
      let remainingPages = Math.ceil((currentCount - 1)/currentLimit);
      remainingPages = remainingPages?remainingPages:1;
      return {
        ...state,
        smsTemplateList: {
          data: state.smsTemplateList.data.filter(
            smsTemplate => smsTemplate._id !== payload
          ),
          count: currentCount - 1,
          page: currentPage <= remainingPages?currentPage.toString(): remainingPages.toString(),
        },
        loadingSMSList: false,
        performDelete: true,
      };
    case GET_SMS_TEMPLATE_BY_ID:
      return {
        ...state,
        currentSMSTemplate: payload,
        loadingSMS: false
      };
    case SMS_TEMPLATE_LIST_UPDATED:
      return {
        ...state,
        smsTemplateList: {
          data: payload.data,
          page: payload.metadata[0].current_page,
          count: payload.metadata[0].totalRecord
        },
        // loadingSMS: true,
        loadingSMSList: false,
        loadingListData: false,
        performDelete: false,
      };
    case SMS_TEMPLATE_SEARCH_PARAMATERS_UPDATE:
      return {
        ...state,
        sortingParams: { ...payload }
      };

    case CHANGE_SMS_TEMPLATE_STATUS:
      return {
        ...state,
        smsTemplateList: {
          ...state.smsTemplateList,
          data: state.smsTemplateList.data.map(smsTemplate =>
            smsTemplate._id === payload._id
              ? { ...smsTemplate, status: payload.status }
              : smsTemplate
          )
        }
      };
    case LOADING_SMS_LIST_DATA:
      return {
        ...state,
        loadingListData: true
      };
    case LOADING_ON_SMS_SUBMIT:
      return {
        ...state,
        loadingSMS: true
      };

    default:
      return state;
  }
}
